/* eslint-disable react/require-default-props,react/destructuring-assignment,react/no-unescaped-entities */

import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { FontAwesome } from '../../../components/FontAwesome';
import { PortalQualificationPropType } from '../../../../CustomPropTypes/PortalPropTypes';
import { PortalJoinQualificationButton } from '../../PortalButton/PortalJoinQualificationButton';
import { LoadableResponsiveImage as ResponsiveImage } from '../../../components/ResponsiveImage/LoadableResponsiveImage';
import './PortalFreeToLearn.scss';
import { titleCase } from '../../../utilities/utilities';

class _PortalFreeToLearn extends React.Component {
  static displayName = 'PortalFreeToLearn';

  static propTypes = {
    backgroundImageUrl: PropTypes.string,
    enrol: PropTypes.func,
    onCtaButtonClicked: PropTypes.func,
    qualification: PortalQualificationPropType,
    showEnrolButton: PropTypes.bool,
    t: PropTypes.func.isRequired,
  };

  static contextTypes = {
    strings: ImmutablePropTypes.map,
  };

  enrol = () => {
    if (_.isFunction(this.props.enrol)) {
      this.props.enrol();
    }
  };

  render() {
    const {
      backgroundImageUrl,
      onCtaButtonClicked,
      qualification,
      showEnrolButton,
      t,
    } = this.props;

    return (
      <portal-free-to-learn>
        <ResponsiveImage
          src={backgroundImageUrl}
          responsive
          background
          backgroundClassName="free-to-learn"
          resizeWidthOnly
          onResize="up"
        >
          <div className="row">
            <div className="columns small-11 small-centered medium-10 medium-centered">
              <h3 className="free-to-learn-title">
                <span>{titleCase(t('free_to_learn'))}</span>
                <span>{t('pay_to_certify')}</span>
              </h3>
              <div className="free-to-learn-subtitle">
                {t('join_and_complete_any_courses_for_free')}
              </div>
              <div className="free-to-learn-features">
                <div className="free-to-learn-feature">
                  <h4>
                    <FontAwesome name="paper-plane" /> {t('learn_it')}
                  </h4>
                  <div>
                    {t('complete_any_course')}{' '}
                    <span className="inline-block">{t('for_free')}</span>
                  </div>
                </div>
                <div className="free-to-learn-feature">
                  <h4>
                    <FontAwesome name="heart" /> {t('love_it')}
                  </h4>
                  <div>
                    {t('experience_first_hand_quality_online_learning')}
                  </div>
                </div>
                <div className="free-to-learn-feature">
                  <h4>
                    <FontAwesome name="certificate" /> {t('certify_it')}
                  </h4>
                  <div>
                    {t('pay_if_you_decide_to')}{' '}
                    <span className="inline-block">
                      {t('get_certified_card')}
                    </span>
                  </div>
                </div>
              </div>
              {showEnrolButton ? (
                <div className="portal-enrol-button-wrapper text-center">
                  <PortalJoinQualificationButton
                    {...{ qualification, onCtaButtonClicked }}
                    onClick={this.enrol}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </ResponsiveImage>
      </portal-free-to-learn>
    );
  }
}

export const PortalFreeToLearn = withTranslation('landingPages')(
  _PortalFreeToLearn
);
